<div>
  <div class="margin-left-md">
    <span class="dot margin-top-md origin"></span>
    <span class="vertical-line"></span>
    <span class="dot"></span>
  </div>
  <div>
    <div>
      @if (origin) {
      <span class="locationLabel " appBlurElement>{{ origin }}</span>
      }
      <app-offer [quote]="driverQuote" [shipmentStatus]="shipment.status" [shipmentOfferRate]="offerRate"
        [isTrip]="isTrip">
      </app-offer>
    </div>
    <div>
      <span class="date-time-label">{{ formattedPickupDateAndTime }}</span>
      <span class="margin-left-sm"><mat-icon svgIcon="time"></mat-icon> </span>
      <span class="date-time-label padding-top-xs">{{ pickupTime }}</span>
    </div>
    <div class="padding-top-lg padding-bottom-lg">
      @if (mode) {
      <span class="offer-type-name ">{{ mode }}</span>
      }
      @if (weight) {
      <span class="offer-type-name margin-left-sm">{{ weight }} kg</span>
      }
      @if (priority) {
      <span class="offer-type-name margin-left-sm priority">High Priority</span>
      }
    </div>
    @if (destination) {
    <span class="locationLabel" appBlurElement>{{ destination }}</span>
    }
    <div>
      <span class="date-time-label">{{ formattedDeliveryDateAndTime }} </span>
      <span class="date-time-label margin-left-sm"><mat-icon svgIcon="time"></mat-icon></span>
      <span class="date-time-label padding-top-xs">{{ deliveryTime }}</span>
    </div>
  </div>
</div>